export default __webpack_public_path__ + "static/media/avatar.78d18eb9.png";